export const GOOGLE_ANALYTICS_ATTRIBUTES = {
  // Content Groups
  cgPageType: 'contentGroup1',
  cgBlogPageType: 'contentGroup2',
  cgProductBrand: 'contentGroup3',
  cgProductVertical: 'contentGroup4',

  // Custom Dimensions
  cdProductVertical: 'dimension1',
  cdPaymentMethod: 'dimension2',
  cdUrl: 'dimension3',
  cdFilter: 'dimension4',
  cdPromoKey: 'dimension5',
  cdProductId: 'dimension6',
  cdProductUrlKey: 'dimension7',
  cdCustomerUUID: 'dimension8',
  cdProductCampaign: 'dimension9',
  cdProductCampaignProductUUID: 'dimension10',
  cdCustomerLoggedInUUID: 'dimension11',
  cdChainId: 'dimension12',
  cdAmount: 'dimension13',
  cdCount: 'dimension14',
  cdOption: 'dimension15',
  cdModifier: 'dimension16',
  cdProductName: 'dimension17',
  cdProductPrimaryCategory: 'dimension18',
  cdExperimentIds: 'dimension19',
  cdProductBrand: 'dimension20',
  cdLocalAmount: 'dimension21',
  cdLocalCurrency: 'dimension22',
  cdCouponCode: 'dimension23',
  cdCodeSplitting: 'dimension24',
  cdSortOrder: 'dimension25',
  cdDigitalWalletCanBeDefaulted: 'dimension26',
  cdDigitalWalletOneClickPurchaseButtonShown: 'dimension27',
  cdNumberOfAvailableAsks: 'dimension28',
  cdSkuUuid: 'dimension30',
  cdHighestBidLocalAmount: 'dimension31',
  cdLowestAskLocalAmount: 'dimension32',
  cdLaunchDarklyExperiments: 'dimension37',
  cdLanguageCode: 'dimension38',
  cdSizeFormatClicked: 'dimension40',
  cdSizeChartLocaleFormat: 'dimension42',
  cdLastSaleAmount: 'dimension43',
  cdPromotionalProduct: 'dimension44',
  cdPaymentServiceProvider: 'dimension45',
  cdBannerCollageName: 'dimension46',
  cdTileCollectionName: 'dimension47',
  cdDestinationType: 'dimension48',
  cdPosition: 'dimension49',
  cdBannerCarouselName: 'dimension50',
  cdProductCollectionName: 'dimension51',
};
